/**
 * Base error class for all application errors.
 * Provides consistent error structure with stack traces and metadata.
 */
export abstract class BaseError extends Error {
	abstract readonly code: string;
	abstract readonly statusCode: number;
	readonly timestamp: Date;
	readonly details?: Record<string, unknown>;

	constructor(message: string, details?: Record<string, unknown>) {
		super(message);
		this.name = this.constructor.name;
		this.timestamp = new Date();
		this.details = details;

		// Capture stack trace if available
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, this.constructor);
		}
	}

	/**
	 * Convert error to a plain object for logging/serialization
	 */
	toJSON(): {
		name: string;
		message: string;
		code: string;
		statusCode: number;
		timestamp: string;
		details?: Record<string, unknown>;
		stack?: string;
	} {
		return {
			name: this.name,
			message: this.message,
			code: this.code,
			statusCode: this.statusCode,
			timestamp: this.timestamp.toISOString(),
			details: this.details || undefined,
			stack: this.stack || undefined,
		};
	}
}
